import { COUNTRY_LANGUAGES_MAP } from "@shared/adminConstants";

export function getIsMultilingualMarket(market) {
  if (!Object.keys(COUNTRY_LANGUAGES_MAP).includes(market)) {
    console.warn(
      `[isMultilingualMarket] - unrecognized market '${market}' received.`
    );
  }

  return COUNTRY_LANGUAGES_MAP[market]?.length > 1;
}
